import { Button, Grid } from "@mui/material";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";

import "./home.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  FormControlLabel,
  Radio,
} from "@mui/material";
import usercalls from "../../Axios";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMoreIcon';
import PropTypes from "prop-types";
import btc from "../../Img/btc.svg";
import ltc from "../../Img/ltc.svg";
import kcs from "../../Img/eth.png";
import Btc from "../../Img/btc.png";
import eth from "../../Img/eth.png";
import top_losers from "../../Img/top_losers.png";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";

import sol from "../../Img/coins/sol.png";
import nodata from "../../Img/newnodta.gif";

import top_gainers from "../../Img/top_gainers.png";
import search from "../../Img/search.svg";

import banimg from "../../Img/banimg_white.png";

import chart_table from "../../Img/chart_table.png";

import b1 from "../../Img/b1.png";
import b2 from "../../Img/b2.png";
import b3 from "../../Img/b3.png";
import right_arw_orange from "../../Img/right_arw_orange.svg";
import c1 from "../../Img/c1.webp";
import c2 from "../../Img/c2.webp";
import c3 from "../../Img/c3.webp";
import c4 from "../../Img/c4.webp";
import qrcode from "../../Img/qrcode.png";

import trade_img from "../../Img/trade_img.png";

import gift from "../../Img/gift.svg";

import tr1 from "../../Img/tr1.svg";
import tr2 from "../../Img/tr2.svg";

import d1 from "../../Img/d1.png";
import d2 from "../../Img/d2.png";

import g1 from "../../Img/g1.svg";
import g2 from "../../Img/g2.svg";
import g3 from "../../Img/g3.svg";
import g4 from "../../Img/g4.svg";

import consts from "../../constant";
import { tableCellClasses } from "@mui/material/TableCell";

import $ from "jquery";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import axios from "axios";
// import Loader from "../Loader";

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Home = () => {
  const [value, setValue] = React.useState(0);
  const [topGainers, setTopGainers] = useState([]);
  const [topLoosers, setTopLoosers] = useState([]);
  const [topVolume, setTopVolume] = useState([]);
  const [allPairs, setAllPairs] = useState([]);
  const navigate = useNavigate();

  const Subws = useRef(null);
  const subPingws = useRef(null);

  const cards2 = [
    {
      img: btc,
      coinname: "TFUEL",
    },
    {
      img: ltc,
      coinname: "AUCTION",
    },
    {
      img: kcs,
      coinname: "FET",
    },
  ];

  const cards3 = [
    {
      img: btc,
      coinname: "ETH",
    },
    {
      img: ltc,
      coinname: "BTC",
    },
    {
      img: kcs,
      coinname: "XRP",
    },
  ];

  const path = usercalls();

  const [market, setmarket] = useState(0);

  const handleChangemarket = (event, newmarket) => {
    setmarket(newmarket);
  };
  const [currentPairs, setCurrentPairs] = useState([]);
  const [oldPairs, setOldPairs] = useState([]);

  const getPairs = async (value) => {
    try {
      if (currentPairs) {
        // UnsubscribeStream(currentPairs)
        setOldPairs(currentPairs);
      }

      const url = `${consts.BackendUrl}/getOwnPairs?page=1&limit=10&search=${value ? value : ""
        }`;
      const response = await path.getCall({ url });
      const result = await response.json();
      if (result?.result?.totalDocs > 0) {
        // setTotalCount(result?.result?.totalDocs);
        setCurrentPairs(result?.result?.docs);
        // getAxiosPairs(result?.result?.docs)
        // subScribeStream(result?.result?.docs);
      } else {
        setCurrentPairs([]);
        // setTotalCount(0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getPairs();
    getAxiosPairs([...cards2, ...cards3]);
  }, []);

  const getAxiosPairs = async (currentPairs) => {
    try {
      axios.withCredentials = true;
      if (currentPairs?.length > 0) {
        const symbol = currentPairs?.map((data) => data?.coinname + "-USDT");
        var data;

        const dts = await axios.post(`${consts.BackendUrl}/kucoin/gettickers`, {
          mode: "spot",
          symbol,
        });
        data = dts.data?.result;
        // console.log(data)

        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            const element = data[i];
            let priceHtml =
              parseFloat(element?.changeRate * 100).toFixed(2) > 0
                ? `<span class="green" > +${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `
                : `<span class="red" > ${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `;

            // $(`.price-${element?.symbol.split('-').join("")}`).html(isNaN(element?.last) ? '0' : Number(element?.last).toFixed(6));
            $(`.pricemarket-${element?.symbol.split("-").join("")}`).html(
              isNaN(element?.last) ? "0" : Number(element?.last).toFixed(6)
            );
            $(`.changemarket-${element?.symbol.split("-").join("")}`).html(
              priceHtml
            );
            // $(`.change-${element?.symbol.split('-').join("")}`).html(priceHtml);
            // $(`.high-${element?.symbol.split('-').join("")}`).html(isNaN(element?.high) ? '0' : Number(element?.high).toFixed(6));
            // $(`.low-${element?.symbol.split('-').join("")}`).html(isNaN(element?.low) ? '0' : Number(element?.low).toFixed(6));
            // $(`.volume-${element?.symbol.split('-').join("")}`).html(isNaN(element?.vol) ? '0' : Number(element?.vol).toFixed(2));
          }
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const [kucoinToken, setKucoinToken] = useState("");

  const generateKucoinToken = async () => {
    try {
      axios.withCredentials = true;
      const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
      const { data } = await axios.get(url);
      if (data.success) {
        let str = data?.result?.replace(/^"(.*)"$/, "$1");
        setKucoinToken(str);
        // console.log(str);
      }
    } catch (err) {
      console.log(err, "error from token");
    }
  };

  const marketSocket = () => {
    try {
      const ws = new WebSocket(
        `wss://ws-api-spot.kucoin.com?token=${kucoinToken}`
      );
      Subws.current = ws;
      ws.onopen = () => {
        // Combine all cards into one array
        const allCards = [...cards2, ...cards3];

        // Create a set to store unique coin names
        const uniqueCoins = new Set();

        // Iterate over all cards and add unique coin names to the set
        allCards.forEach((card) => {
          uniqueCoins.add(card.coinname);
        });

        // Convert the set to an array and map to the desired format
        const uniqueCoinArray = Array.from(uniqueCoins).map(
          (coin) => `${coin}-USDT`
        );
        const curpar = currentPairs?.map((cp) =>
          cp.pair_symbol.split("_").join("-")
        );
        const merge = [...uniqueCoinArray, ...curpar];
        const symbols = merge.join(",");
        // console.log(s)

        const priceApicall = {
          id: new Date().getTime(),
          type: "subscribe",
          topic: `/market/snapshot:${symbols}`,
          response: true,
        };
        // const priceApicall2 = {
        //   "id": new Date().getTime(),
        //   "type": "subscribe",
        //   "topic": `/market/snapshot:${merge}`,
        //   "response": true
        // };
        ws.send(JSON.stringify(priceApicall));
        // ws.send(JSON.stringify(priceApicall2));
      };

      ws.onmessage = (event) => {
        const jsons = JSON.parse(event.data);
        const json = jsons ? jsons?.data?.data : "";
        // console.log(json,"markdata")
        try {
          let priceHtml =
            parseFloat(json?.changeRate * 100).toFixed(2) > 0
              ? `<span class="green" > +${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `
              : `<span class="red" > ${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `;

          $(`.pricemarket-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice).toFixed(6)
          );
          // $(`.change - ${ json?.s }`).html(isNaN(json?.P) ? '0' : Number(json?.P).toFixed(2) + "%");
          $(`.changemarket-${json?.symbol.split("-").join("")}`).html(
            priceHtml
          );
          $(`.price-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice).toFixed(6)
          );
          $(`.change-${json?.symbol.split("-").join("")}`).html(priceHtml);
          $(`.high-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.high) ? "0" : Number(json?.high).toFixed(6)
          );
          $(`.low-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.low) ? "0" : Number(json?.low).toFixed(6)
          );
          $(`.volume-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.vol) ? "0" : Number(json?.vol).toFixed(2)
          );
        } catch (error) {
          console.error("Error updating price:", error);
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = (e) => {
        console.log("WebSocket Connection Closed", e.code);
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) { }
  };

  useEffect(() => {
    generateKucoinToken();
  }, []);

  useEffect(() => {
    if (Subws.current) {
      Subws.current?.close();
      Subws.current = null;
    }
    marketSocket();

    subPingws.current = setInterval(() => {
      if (Subws.current?.readyState === WebSocket.OPEN) {
        const pingMsg = {
          id: `ping-${Date.now()}`,
          type: "ping",
        };
        Subws.current?.send(JSON.stringify(pingMsg));
        // console.log('Sent ping price:', pingMsg.id);
      }
    }, 20000);

    return () => {
      clearInterval(subPingws.current);
    };
  }, [currentPairs, kucoinToken]);

  // Debounced function
  const debouncedSubmit = useCallback(
    debounce((value) => {
      getPairs(value);
    }, 300), // 300ms debounce delay
    []
  );

  // Effect to call debounced function when search changes
  useEffect(() => {
    debouncedSubmit();
  }, []);

  const topGain = topGainers.map((table) => (
    <TableRow className="cursor">
      <TableCell align="center">
        <div className="display-1 coin-gap">
          {/* <div className="star-img">
                        <img src={star} alt="star" />
                    </div> */}
          {/* <div className="coin-img">
                        <img src={table?.img ? table?.img : Btc} alt="coin" />
                    </div> */}
          <div className="coin-name">
            <p> {table?.symbol}</p>
            {/* <span> {table.coinname}</span> */}
          </div>
        </div>
      </TableCell>
      <TableCell align="center">
        <div className={`pricess-${table?.symbol} grey`}>
          {table?.lastPrice}
        </div>
      </TableCell>
      <TableCell align="center" className={`24hpc-${table?.symbol} red`}>
        {table?.priceChangePercent}
      </TableCell>
      <TableCell align="center" className={`vol-${table?.symbol}`}>
        {table?.volume}
      </TableCell>
      <TableCell align="center">
        {" "}
        <img src={chart_table} alt="star" />
      </TableCell>
      {/* <TableCell align="center">
                <div className="actions" >
                    <Link to={`/trade/${table?.symbol}`}>Trade</Link>
                </div>
            </TableCell> */}
    </TableRow>
  ));

  const [status, setStatus] = useState(window.localStorage.getItem("Rikosta"));

  const getTopGainers = async () => {
    try {
      const url = `${consts.BackendUrl}/topgainers`;
      const response = await path.getCall({ url });
      const result = await response.json();

      if (result?.success) {
        // Extract symbols from top gainers, losers, and volume pairs and Formatting For webSocket
        const topGainersSymbols =
          result?.topgainers?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];
        const topLosersSymbols =
          result?.toplosers?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];
        const topVolumeSymbols =
          result?.topvolume?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];

        setTopGainers(result?.topgainers);
        setTopLoosers(result?.toplosers);
        setTopVolume(result?.topvolume);
        setAllPairs([
          ...topGainersSymbols,
          ...topLosersSymbols,
          ...topVolumeSymbols,
        ]);
      }
    } catch (error) {
      console.log(error, "error getting topgainers");
    }
  };

  useEffect(() => {
    getTopGainers();
  }, []);

  const currentSocket = async () => {
    try {
      const ws = new WebSocket("wss://stream.binance.com:9443/ws");
      // setCurrentSoc(ws)
      ws.onopen = (event) => {
        const priceApicall = {
          method: "SUBSCRIBE",
          params: allPairs,
          id: 1,
        };
        ws.send(JSON.stringify(priceApicall));
      };

      ws.onmessage = function (event) {
        const json = JSON.parse(event.data);
        // console.log(json, "jsonevent");
        try {
          $(`.pricess-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.c).toFixed(4)}</span>`
          );
          $(`.24hp-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.p).toFixed(2)}</span>`
          );
          $(`.24hpc-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.P).toFixed(2) + "%"}</span>`
          );
          $(`.open-${json?.s}`).html(Number(json?.o).toFixed(2));
          $(`.vol-${json?.s}`).html(Number(json?.v).toFixed(2));
          $(`.high-${json?.s}`).html(Number(json?.h).toFixed(2));
          $(`.low-${json?.s}`).html(Number(json?.l).toFixed(2));
        } catch (error) {
          console.log(error, "err");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed");
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) {
      console.log("🚀 ~ currentSocket ~ error:", error);
    }
  };

  useEffect(() => {
    if (allPairs.length > 0) {
      currentSocket();
    }
  }, [allPairs]);

  const [expanded, setExpanded] = React.useState("panel1");

  const handle_accordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const options = {
    items: 3,
    margin: 10,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div className="market-full homepage">
      <Header />
      {/* <Loader/> */}
      <section className="banner">
        <div className="contain-width">
          <Grid container xs={{ alignItems: "center !important" }}>
            <Grid
              items
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={{ margin: "auto" }}
            >
              <h1>
                Next-Gen <span> Crypto </span> Destination!
              </h1>
              <ul>
                <li>Secure</li>
                <li>Trade</li>
                <li>Earn</li>
              </ul>
              <p className="earn">
                {" "}
                <img src={gift} alt="img" /> Earn <span> 25 USDT </span> Welcome
                Bonus
              </p>
              <div className="b_flx display-1 flex-wrap">
                {status ? (
                  <Link to={"/dashboard"} className="dash_b display-3">
                    Dashboard
                  </Link>
                ) : (
                  <Link to={"/register"} className="sign_up display-3">
                    Sign Up Now
                  </Link>
                )}
              </div>

              <p className="download">Download App</p>
              <div className="o_flx">
                <Link to={"#"}>Scan QR</Link>
                <Link to={"#"}>
                  <svg
                    width="21"
                    height="23"
                    viewBox="0 0 21 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.64368 0.881262L16.2437 7.58126L12.9437 10.8813L2.54368 0.581262C2.74368 0.581262 3.04368 0.481262 3.24368 0.481262C3.74368 0.481262 4.24368 0.581262 4.64368 0.881262ZM0.643677 19.8813V3.08126C0.643677 2.28126 1.04368 1.58126 1.64368 1.08126L12.1437 11.5813L1.74368 21.9813C1.04368 21.4813 0.643677 20.6813 0.643677 19.8813ZM4.64368 22.1813C4.04368 22.4813 3.34368 22.5813 2.74368 22.4813L12.9437 12.3813L16.1437 15.5813L4.64368 22.1813ZM19.1437 13.7813L17.0437 14.9813L13.5437 11.5813L17.0437 8.08126L19.0437 9.28126C19.8437 9.78126 20.3437 10.5813 20.3437 11.5813C20.4437 12.3813 19.9437 13.2813 19.1437 13.7813Z"
                      fill="white"
                    />
                  </svg>
                </Link>
                <Link to={"#"}>
                  <svg
                    width="21"
                    height="25"
                    viewBox="0 0 21 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.1132 4.32775C14.5776 3.80492 14.9316 3.19763 15.155 2.54075C15.3785 1.88387 15.4669 1.19035 15.4152 0.5C13.9897 0.612417 12.6664 1.26742 11.7305 2.32388C11.2823 2.83022 10.9427 3.41926 10.7317 4.05614C10.5208 4.69301 10.4427 5.36477 10.5023 6.03163C11.1976 6.03729 11.885 5.88656 12.5112 5.59109C13.1373 5.29563 13.6855 4.86336 14.1132 4.32775ZM17.2084 13.2552C17.2166 12.3357 17.4645 11.4335 17.9287 10.6336C18.3929 9.83368 19.058 9.16253 19.8613 8.68346C19.3543 7.96979 18.6841 7.38134 17.9038 6.96478C17.1235 6.54822 16.2546 6.315 15.366 6.28362C13.45 6.09163 11.6814 7.37554 10.6619 7.37554C9.64252 7.37554 8.2055 6.30761 6.60882 6.33161C5.56499 6.36521 4.54789 6.66253 3.65672 7.19458C2.76556 7.72663 2.03075 8.47525 1.52398 9.36741C-0.637689 13.0392 0.971281 18.4988 3.13295 21.4626C4.11553 22.9145 5.34375 24.5584 6.965 24.4984C8.58625 24.4384 9.11439 23.5145 10.9936 23.5145C12.8727 23.5145 13.45 24.4984 15.0467 24.4624C16.6434 24.4264 17.7733 22.9745 18.8051 21.5226C19.5359 20.4685 20.1068 19.3167 20.5 18.1028C19.5266 17.6973 18.6961 17.022 18.1112 16.1605C17.5262 15.299 17.2123 14.289 17.2084 13.2552Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
              {/* {status ? (
                <></>
              ) : (
                <div class="input_grp">
                  <div class="input_txt right cursor-pointer">
                    <input
                      type="text"
                      placeholder="Email"
                      onChange={(e) => {
                        window.localStorage.setItem("email", e.target.value);
                      }}
                    />
                    <Link to={"/register"}>Let's Roll</Link>
                  </div>
                </div>
              )} */}
            </Grid>
            <Grid
              items
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={{ marginTop: "60px", md: { margin: "auto" } }}
            >
              <div className="img_b">
                <img src={banimg} alt="img" />
                {/* <img src={banimg_white} alt="img" className="light" /> */}
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* <section className="banner_data mquee">
        <div className="contain-width">
          <div>
            <div className="left display-1">
              <a href="#">
                {" "}
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/telegram-app.png"
                  alt="telegram-app"
                />
              </a>
              <p>
                Join Our Country Preferable Telegram Community and Stay
                Connected.{" "}
              </p>
            </div>
            <div className="display-1">
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/facebook-new.png"
                  alt="facebook-new"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/instagram-new.png"
                  alt="instagram-new"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color/50/youtube-play.png"
                  alt="youtube-play"
                />
              </a>
              <p>
                Our 6 Social Media official account’s you will Claim 2 USDT{" "}
              </p>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color-glass/50/medium-logo.png"
                  alt="medium-logo"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/ios/50/twitterx--v1.png"
                  alt="twitterx--v1"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color/50/linkedin.png"
                  alt="linkedin"
                />
              </a>
              <a href="#">
                {" "}
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/telegram-app.png"
                  alt="telegram-app"
                />
              </a>
            </div>
          </div>
          <div>
            <div className="left display-1">
              <a href="#">
                {" "}
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/telegram-app.png"
                  alt="telegram-app"
                />
              </a>
              <p>
                Join Our Country Preferable Telegram Community and Stay
                Connected.{" "}
              </p>
            </div>
            <div className="display-1">
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/facebook-new.png"
                  alt="facebook-new"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/instagram-new.png"
                  alt="instagram-new"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color/50/youtube-play.png"
                  alt="youtube-play"
                />
              </a>
              <p>
                Our 6 Social Media official account’s you will Claim 2 USDT{" "}
              </p>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color-glass/50/medium-logo.png"
                  alt="medium-logo"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/ios/50/twitterx--v1.png"
                  alt="twitterx--v1"
                />
              </a>
              <a href="#">
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/color/50/linkedin.png"
                  alt="linkedin"
                />
              </a>
              <a href="#">
                {" "}
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/fluency/50/telegram-app.png"
                  alt="telegram-app"
                />
              </a>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="ban_blw">
        <div className="contain-width">
          <h2 className="h2tag">Bonanza Events</h2>
          <OwlCarousel className="owl-theme" {...options}>
            <div className="box">
              <div>
                <span>Registration Bonanza</span>
                <h3>Get 25 USDT</h3>
                <h5>instantly as part of our exclusive registration bonanza</h5>
                <Link to={"/register"}>Join Now</Link>
              </div>
              <div>
                <img src={blw1} alt="img" />
              </div>
            </div>
            <div className="box">
              <div>
                <span>Referral Bonus</span>
                <h3>Get 02 USDT</h3>
                <h5>for every successful referral.</h5>
                <Link to={"/register"}>Join Now</Link>
              </div>
              <div>
                <img src={blw2} alt="img" />
              </div>
            </div>

            <div className="box">
              <div>
                <span>Social Media Bonanza</span>
                <h3>Get 02 USDT</h3>
                <h5>follow us on social media and Earn 2 USDT</h5>
                <Link to={"/register"}>Join Now</Link>
              </div>
              <div>
                <img src={blw3} alt="img" />
              </div>
            </div>
            <div className="box">
              <div>
                <span>Social Media Bonanza</span>
                <h3>Get 02 USDT</h3>
                <h5>follow us on social media and Earn 2 USDT</h5>
                <Link to={"/register"}>Join Now</Link>
              </div>
              <div>
                <img src={blw3} alt="img" />
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section> */}
      <section className="home_market">
        <div className="contain-width">
          <div className="display-2">
            <h2 className="h_2" style={{ color: "var(--clr-font)" }}>
              Crypto Market Today
            </h2>
            {/* <Link to={"/market"} className="see-more">
              See More{"  "}
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.25031 4.24996H6.94516L4.46915 1.78451C4.32785 1.6434 4.2485 1.45201 4.2485 1.25245C4.2485 1.05289 4.32785 0.8615 4.46915 0.720387C4.61045 0.579275 4.80207 0.5 5.00187 0.5C5.20167 0.5 5.3933 0.579275 5.5346 0.720387L9.28614 4.46731C9.35446 4.53856 9.40801 4.6226 9.44371 4.71459C9.51875 4.89703 9.51875 5.10166 9.44371 5.28414C9.40801 5.37612 9.35446 5.46016 9.28614 5.53141L5.5346 9.27834C5.46485 9.34857 5.38186 9.40434 5.29044 9.44236C5.19898 9.48042 5.10091 9.5 5.00187 9.5C4.90284 9.5 4.80474 9.48042 4.71331 9.44236C4.62189 9.40434 4.5389 9.34857 4.46915 9.27834C4.39884 9.20866 4.343 9.12579 4.3049 9.03448C4.26684 8.94316 4.24723 8.84521 4.24723 8.74629C4.24723 8.64736 4.26684 8.54941 4.3049 8.45806C4.343 8.36675 4.39884 8.28387 4.46915 8.2142L6.94516 5.74872H1.25031C1.05132 5.74872 0.860473 5.66979 0.719761 5.52924C0.57905 5.38873 0.5 5.19811 0.5 4.99936C0.5 4.80061 0.57905 4.61 0.719761 4.46945C0.860473 4.32894 1.05132 4.24996 1.25031 4.24996Z"
                  fill="#566FFF"
                />
              </svg>
            </Link> */}
          </div>
          <Grid container spacing={2} alignItems={"center"}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="ticket-box" style={{ paddingTop: "1px" }}>
                <div className="market-current-history">
                  <div className="inbox">
                    <div className="display-2 tab_bdr">
                      <Tabs
                        value={market}
                        onChange={handleChangemarket}
                        aria-label="basic tabs example"
                      >
                        {/* <Tab label="Hot Derivatives" {...a11yProps(1)} /> */}
                        <Tab label="Hot Coins" {...a11yProps(0)} />
                      </Tabs>
                    </div>
                    <CustomTabPanel
                      value={market}
                      index={0}
                      class="tab-content"
                    >
                      <div className="market-table">
                        <TableContainer sx={{ marginBottom: "10px" }}>
                          <Table
                            sx={{
                              minWidth: 650,
                              [`& .${tableCellClasses.root}`]: {
                                borderBottom: "none",
                              },
                            }}
                            aria-label="simple table"
                            className="market-table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell align="left">#</TableCell>
                                <TableCell align="left">Name</TableCell>
                                <TableCell align="center">Price</TableCell>
                                <TableCell align="center">
                                  <span className="highlight-text">24h </span>{" "}
                                  changes
                                </TableCell>
                                <TableCell align="center">24h High</TableCell>
                                <TableCell align="center">24h Low</TableCell>
                                <TableCell align="center">24h Volume</TableCell>
                                <TableCell align="center">Action</TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {currentPairs?.length > 0 ? (
                                currentPairs?.map((row, index) => (
                                  <TableRow className="tr_row" key={index}>
                                    <TableCell align="left">
                                      {" "}
                                      <span>{index + 1}</span>
                                      {/* <Checkbox
                                {...label}
                                icon={<StarOutlineRoundedIcon />}
                                checkedIcon={<StarOutlineRoundedIcon />}
                              /> */}
                                    </TableCell>
                                    <TableCell>
                                      <div className="d-flex align-items-center gap-10">
                                        <div>
                                          <ImageWithFallback
                                            src={row?.icon}
                                            name={row?.base_asset_name}
                                            alt="coin-img"
                                          />
                                        </div>
                                        <div>{row?.base_asset_name}</div>
                                      </div>
                                    </TableCell>
                                    <TableCell align="center">
                                      <span
                                        className={`price-${row?.base_asset_name}USDT`}
                                      >
                                        {Number(row?.last)?.toFixed(6)}
                                      </span>
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      sx={
                                        row.change?.includes("-")
                                          ? { color: "#F65454" }
                                          : { color: "#1A8F5C" }
                                      }
                                    >
                                      <span
                                        className={`change-${row?.base_asset_name
                                          }USDT ${Number(row?.changeRate * 100) >= 0
                                            ? "green"
                                            : "red"
                                          }`}
                                      >
                                        {Number(row?.changeRate * 100)?.toFixed(
                                          2
                                        )}{" "}
                                        %
                                      </span>
                                    </TableCell>
                                    <TableCell align="center">
                                      <span
                                        className={`high-${row?.base_asset_name}USDT`}
                                      >
                                        {row?.high}
                                      </span>
                                    </TableCell>
                                    <TableCell align="center">
                                      <span
                                        className={`low-${row?.base_asset_name}USDT`}
                                      >
                                        {row?.low}
                                      </span>
                                    </TableCell>
                                    <TableCell align="center">
                                      <span
                                        className={`volume-${row?.base_asset_name}USDT`}
                                      >
                                        {row?.vol}
                                      </span>
                                    </TableCell>
                                    <TableCell align="center">
                                      {/* <Button variant="text" className="highlight-text">
                                Details
                              </Button> */}
                                      <Button
                                        variant="text"
                                        className="highlight-text"
                                        onClick={() => {
                                          navigate(
                                            `/trade/${row?.base_asset_name}_USDT`
                                          );
                                        }}
                                      >
                                        Trade
                                      </Button>{" "}
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow className="tr_row text-center">
                                  <TableCell
                                    align="center !important"
                                    colSpan={8}
                                  >
                                    <img src={nodata} alt="nodata" />
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </CustomTabPanel>
                    <CustomTabPanel
                      value={market}
                      index={1}
                      class="tab-content"
                    >
                      <div className="market-table">
                        <TableContainer>
                          <Table aria-label="simple table" stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell align="left">Pair</TableCell>
                                <TableCell align="center">Price</TableCell>
                                <TableCell align="center">24h Change</TableCell>
                                <TableCell align="center">Volume</TableCell>
                                <TableCell align="center">24h chart</TableCell>
                                {/* <TableCell align="right">24h Volume</TableCell> */}
                                {/* <TableCell align="center">Action</TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>{topGain}</TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </CustomTabPanel>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="market_overview contain-width m-5">
                <div className="box">
                  <div className="abv_flx">
                    <div className="flx">
                      <img src={top_gainers} alt="img" />
                      <h5>Top Gainers</h5>
                    </div>
                    {/* <Link >
                           More <KeyboardArrowRightIcon />
                         </Link> */}
                  </div>
                  {cards2?.map((row, i) => (
                    <ul key={i}>
                      <li>
                        <div>
                          <span className="num">{i + 1}</span>
                          <span>
                            <img
                              src={`${consts?.imageurl}${row?.coinname}.png`}
                              alt={row.img}
                              className="coin"
                            />
                          </span>
                          <span>{row?.coinname}</span>{" "}
                        </div>
                        <div className={`pricemarket-${row?.coinname}USDT`}>
                          0
                        </div>
                        <div>
                          <span className={`changemarket-${row?.coinname}USDT`}>
                            0
                          </span>
                        </div>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
              <div className="market_overview contain-width m-5">
                <div className="box">
                  <div className="abv_flx">
                    <div className="flx">
                      <img src={top_losers} alt="img" />
                      <h5>Top Volume Coin</h5>
                    </div>
                    {/* <Link>
                      More <KeyboardArrowRightIcon />
                    </Link> */}
                  </div>
                  {cards3?.map((row, i) => (
                    <ul key={i}>
                      <li>
                        <div>
                          <span className="num">{i + 1}</span>
                          <span>
                            <img
                              src={`${consts?.imageurl}${row?.coinname}.png`}
                              alt={row.img}
                              className="coin"
                            />
                          </span>
                          <span>{row?.coinname}</span>{" "}
                        </div>
                        <div className={`pricemarket-${row?.coinname}USDT`}>
                          0
                        </div>
                        <div>
                          <span className={`changemarket-${row?.coinname}USDT`}>
                            0
                          </span>
                        </div>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
          <Link to={"/market"} className="view_more">
            View More
          </Link>
        </div>
      </section>
      <section className="trade_any">
        <div className="contain-width">
          <Grid spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={10}
              xl={10}
              sx={{ margin: "auto" }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={7}
                  sx={{ margin: "auto" }}
                >
                  <h2 className="h_2">Trade anytime, anywhere</h2>
                  <div className="qr_b">
                    <img src={qrcode} alt="img" />
                    <div>
                      <div className="scan">Scan the QR code</div>
                      <h5>Dreamster-Exchange for iOS/Android</h5>
                    </div>
                  </div>
                  <div className="r_f">
                    <div>
                      <img src={tr1} alt="img" />
                      <span>App Store</span>
                    </div>
                    <div>
                      <img src={tr2} alt="img" />
                      <span>Google Play</span>
                    </div>
                    {/* <div>
                      <img src={tr3} alt="img" />
                      <span>Test Flight</span>
                    </div>
                    <div>
                      <img src={tr4} alt="img" />
                      <span>Android APK</span>
                    </div> */}
                  </div>
                  {/* <ul>
                    <li>
                      <h6>1,000 BTC</h6>
                      <p>Protection fund</p>
                    </li>
                    <li>
                      <h6>28,942,453,169</h6>
                      <p>Average daily trading volume (USDT)</p>
                    </li>
                    <li>
                      <h6>5 Million+</h6>
                      <p>Playstore Downloads</p>
                    </li>
                    <li>
                      <h6>8 Million +</h6>
                      <p>Number of users</p>
                    </li>
                  </ul> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={5}
                  sx={{ margin: "auto", textAlign: "center" }}
                >
                  <img src={trade_img} alt="img" style={{ maxWidth: "70%" }} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="discover_more discover-features">
        <div className="contain-width">
          <h2 className="h_2">Discover More Features</h2>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                    <h5>Dreamster-Exchange Future Trade</h5>
                    <p>
                      Dreamster-Exchange Future Trade is a cutting-edge platform
                      designed for crypto and financial futures trading
                    </p>
                    <Link to={"/future/ETH_USDT"} className="link">
                      Details
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                          fill="#566FFF"
                        />
                      </svg>
                    </Link>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={5}
                    xl={5}
                    sx={{ margin: "auto", textAlign: "center" }}
                  >
                    <img src={d1} alt="img" width={150} />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                    <h5>Dreamster-Exchange Staking</h5>
                    <p>
                      Maximize your returns by staking Dreamster-Exchange coin
                      with tailored plans and attractive interest rates.
                    </p>
                    <Link to={"/stake"} className="link">
                      Details
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                          fill="#566FFF"
                        />
                      </svg>
                    </Link>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={5}
                    xl={5}
                    sx={{ margin: "auto", textAlign: "center" }}
                  >
                    <img src={d2} alt="img" width={150} />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h6>Trading</h6>
                <p>
                  Trade cryptocurrencies easily with real-time tracking on our
                  secure platform.
                </p>
                <Link to={"/trade/BTC_USDT?type=spot"} className="round">
                  <span className="feature-btn-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                        fill="#566FFF"
                      />
                    </svg>
                  </span>
                  <span className="feature-btn-text">Trading</span>
                </Link>
              </div>
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={3}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h6>Voting</h6>
                <p>
                  Vote to list Dreamster-Exchange Coin on exchanges and earn 1 USDT
                  per vote!
                </p>

                <Link to={"/underconstruction"} className="round">
                  <span className="feature-btn-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                        fill="#566FFF"
                      />
                    </svg>
                  </span>
                  <span className="feature-btn-text">Voting</span>
                </Link>
              </div>
            </Grid> */}
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={3}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h6>Connect Metamask </h6>
                <p>
                  Link your MetaMask wallet to Dreamster-Exchange for easy and secure
                  crypto management.
                </p>
                <Link to={"/underconstruction"} className="round">
                  <span className="feature-btn-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                        fill="#566FFF"
                      />
                    </svg>
                  </span>
                  <span className="feature-btn-text">Connect</span>
                </Link>
              </div>
            </Grid> */}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h6>Community </h6>
                <p>
                  Join the Dreamster-Exchange community to connect, learn, and
                  grow in blockchain and crypto.
                </p>
                <Link to={"/underconstruction"} className="round">
                  <span className="feature-btn-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.37547 5.87494H9.91774L6.20372 2.17677C5.99178 1.9651 5.87275 1.67801 5.87275 1.37867C5.87275 1.07933 5.99178 0.79225 6.20372 0.580581C6.41568 0.368912 6.70311 0.25 7.00281 0.25C7.30251 0.25 7.58995 0.368912 7.8019 0.580581L13.4292 6.20097C13.5317 6.30784 13.612 6.4339 13.6656 6.57188C13.7781 6.84554 13.7781 7.15249 13.6656 7.42621C13.612 7.56419 13.5317 7.69024 13.4292 7.79712L7.8019 13.4175C7.69728 13.5229 7.57279 13.6065 7.43566 13.6635C7.29846 13.7206 7.15137 13.75 7.00281 13.75C6.85426 13.75 6.70711 13.7206 6.56997 13.6635C6.43283 13.6065 6.30835 13.5229 6.20372 13.4175C6.09826 13.313 6.0145 13.1887 5.95735 13.0517C5.90026 12.9147 5.87084 12.7678 5.87084 12.6194C5.87084 12.471 5.90026 12.3241 5.95735 12.1871C6.0145 12.0501 6.09826 11.9258 6.20372 11.8213L9.91774 8.12309H1.37547C1.07698 8.12309 0.790709 8.00468 0.579642 7.79386C0.368575 7.58309 0.25 7.29717 0.25 6.99904C0.25 6.70092 0.368575 6.415 0.579642 6.20417C0.790709 5.99341 1.07698 5.87494 1.37547 5.87494Z"
                        fill="#566FFF"
                      />
                    </svg>
                  </span>
                  <span className="feature-btn-text">Community</span>
                </Link>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="build">
        <div className="contain-width">
          <h2 className="h_2">Claim your Rewards</h2>
          <Grid container spacing={2} sx={{ justifyContent: "center" }}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Top Up</h5>
                <p>
                  Top up 100 USDT worth of <br /> Dreamster-Exchange to get
                  started.
                </p>
                <Link to={`/deposit`}>
                  Top-up <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box">
                  <img src={b1} alt="img" />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Flexible Staking</h5>
                <p>
                  Stake your Dreamster-Exchange on Dreamster-Exchange <br /> for
                  90 days to earn rewards.
                </p>
                <Link to={`/staking`}>
                  Stake <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box">
                  <img src={b2} alt="img" />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Withdraw</h5>
                <p>
                  Complete your KYC and instantly <br /> withdraw your USDT
                  bonanza!
                </p>
                <Link to={`/withdraw`}>
                  Withdraw <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box portfolio">
                  <img src={b3} alt="img" />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="amazing_feature">
        <div className="contain-width">
          <h2 className="h_2">Amazing Features of Dreamster-Exchange</h2>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="gr_b mrg_b">
                <img src={g1} alt="img" />
                <h5>Impressive Dashboard</h5>
                <p>
                  Stay on top of your game with our comprehensive dashboard,
                  designed to keep you proactive and informed.
                </p>
              </div>
              <div className="gr_b">
                <img src={g2} alt="img" />
                <h5>Live Tracking</h5>
                <p>
                  Update your records and manage withdrawals effortlessly with
                  up-to-date tracking for all your transactions.
                </p>
              </div>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <div className="l_gb">
                <h5>iOS & Android App</h5>
                <p>Available Now</p>
                <div className="text-center">
                  <img src={feature} alt="img" />
                </div>
              </div>
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="gr_b mrg_b">
                <img src={g3} alt="img" />
                <h5>Enhanced Updates</h5>
                <p>
                  Gain insights with advanced profit & loss tracking to make
                  well-informed trading decisions.
                </p>
              </div>
              <div className="gr_b">
                <img src={g4} alt="img" />
                <h5>Referral Program</h5>
                <p>
                  Boost your earnings by referring others. Use your referral
                  link to earn rewards and maximize profits through trading.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* <section className="ultra_side">
        <div className="contain-width">
          <h2 className="h_2">Dreamster-Exchange by Your Side</h2>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="ubox">
                <h5>24/7 Customer Service</h5>
                <div className="flx">
                  <p>
                    Get quick answers and support with our FAQs and guides. For
                    personalized assistance, our team is available 24/7.
                  </p>
                  <div>
                    <a href="#">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.99 0.00976562C7.15374 0.00976562 -0.0100098 7.17353 -0.0100098 16.0097C-0.0100098 24.846 7.15374 32.0098 15.99 32.0098C24.8263 32.0098 31.99 24.846 31.99 16.0097C31.99 7.17353 24.8263 0.00976562 15.99 0.00976562ZM24.4275 20.9523C24.4264 21.3762 24.2575 21.7822 23.9578 22.082C23.658 22.3816 23.252 22.5506 22.8281 22.5517H9.15187C8.72804 22.5506 8.32191 22.3816 8.02221 22.082C7.72252 21.7822 7.55365 21.3762 7.55249 20.9523V12.5922L15.9863 16.7998L24.4275 12.6805V20.9523ZM24.4275 11.1035L15.9937 15.2198L7.55249 11.0097C7.56861 10.5963 7.7439 10.2051 8.04172 9.91789C8.33955 9.63067 8.73686 9.46967 9.15062 9.46853H22.8281C23.2519 9.46968 23.6578 9.63847 23.9576 9.93803C24.2572 10.2376 24.4262 10.6435 24.4275 11.0673V11.1035Z"
                          fill="#566FFF"
                        />
                      </svg>
                      <span>info@Dreamster-Exex.com</span>
                      <img src={right_arw_orange} alt="img" />
                    </a>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={{ display: "flex" }}
            >
              <div className="ubox join-community">
                <h5>Join Our Community</h5>
                <div className="flx">
                  <p>
                    Become part of our thriving community and stay connected
                    with the latest updates, exclusive offers, and valuable
                    insights. Engage with fellow crypto enthusiasts, share your
                    experiences, and be at the forefront of our exciting journey
                  </p>
                  <div className="bdr">
                    <p>Community</p>
                    <a href="#">
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.4847 16.4296C32.4847 25.2634 25.3234 32.4246 16.4897 32.4246C7.65583 32.4246 0.494629 25.2634 0.494629 16.4296C0.494629 7.59577 7.65583 0.43457 16.4897 0.43457C25.3234 0.43457 32.4847 7.59577 32.4847 16.4296ZM10.8814 14.8702C9.27143 15.5676 7.61723 16.2841 6.10462 17.1107C5.31477 17.6844 6.36452 18.0903 7.34936 18.471C7.50593 18.5315 7.66085 18.5914 7.80648 18.6513C7.92766 18.6882 8.0509 18.7271 8.17577 18.7666C9.27109 19.1128 10.4925 19.4989 11.5558 18.9182C13.3027 17.9226 14.9512 16.7716 16.5983 15.6215C17.138 15.2447 17.6775 14.868 18.2205 14.4969C18.2458 14.4808 18.2745 14.4623 18.3059 14.4421C18.7684 14.1447 19.8083 13.4759 19.4236 14.3975C18.514 15.3845 17.5396 16.2582 16.5599 17.1367C15.8997 17.7286 15.237 18.3228 14.5902 18.9553C14.0267 19.4094 13.4417 20.3228 14.0726 20.9588C15.5256 21.968 17.0014 22.9528 18.4764 23.9369C18.9563 24.2572 19.4362 24.5774 19.9151 24.8984C20.7269 25.5414 21.9955 25.0212 22.174 24.0165C22.2534 23.5542 22.333 23.0921 22.4127 22.6298C22.8531 20.0755 23.2935 17.5204 23.6826 14.9578C23.7355 14.5559 23.7955 14.1539 23.8555 13.7518C24.0008 12.7771 24.1464 11.8012 24.1918 10.8212C24.0747 9.84332 22.8796 10.0583 22.2144 10.2782C18.7957 11.5688 15.4112 12.9551 12.0401 14.3658C11.6582 14.5337 11.2711 14.7013 10.8814 14.8702Z"
                          fill="#566FFF"
                        />
                      </svg>
                      <span>Telegram Community</span>
                      <img src={right_arw_orange} alt="img" />
                    </a>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section> */}
      <section className="faq_sec">
        <div className="contain-width">
          <div className="faq_h">
            <h6>Question & Answer</h6>
            <h2 className="h_2">Frequently Asked Questions (FAQ)</h2>
            <p>Quick Answers to Your Most Common Questions.</p>
          </div>
          <div>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel1"}
              onChange={handle_accordion("panel1")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography component={"h3"}>
                  What is Dreamster-Exchange?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  {" "}
                  Dreamster-Exchange is a global cryptocurrency platform that
                  enables users to trade Bitcoin, Ethereum, BNB,
                  Dreamster-Exchange, and over 150 other cryptocurrencies with
                  security and efficiency.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel2"}
              onChange={handle_accordion("panel2")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography component={"h3"}>
                  Who is the Founder of Dreamster-Exchange?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel3"}
              onChange={handle_accordion("panel3")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel3d-content"
                id="panel3d-header"
              >
                <Typography component={"h3"}>
                  How Do I Participate in the 25 USDT Bonanza?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel4"}
              onChange={handle_accordion("panel4")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel4d-content"
                id="panel4d-header"
              >
                <Typography component={"h3"}>
                  Can I Create Multiple Accounts to Receive More USDT?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel5"}
              onChange={handle_accordion("panel5")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel5d-content"
                id="panel5d-header"
              >
                <Typography component={"h3"}>
                  Can I Earn Additional USDT through Referrals?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </section>

      {/* <section className="home_secs">
                <div className="contain-width">
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <div className="img_box">
                                <img src={home_sec1} alt="img" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <h2 className="h_2" >Top-class experience in digital assets investment</h2>
                            <p>With low barriers to entry, we will offer you all-in-one investment services in derivatives
                                and finance based on spot trading.</p>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className="home_secs home_secs_chg">
                <div className="contain-width">
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <h2 className="h_2" >Diversified trading options</h2>
                            <p>A wide range of trading products can help you explore and play with cryptocurrencies, including spot, leverage, futures, ETF, index, and other trading varieties.</p>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <div className="img_box">
                                <img src={home_sec2} alt="img" />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className="home_secs">
                <div className="contain-width">
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <div className="img_box">
                                <img src={home_sec3} alt="img" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }} >
                            <h2 className="h_2" >Top security risk control system</h2>
                            <p>Industry-leading security technology and 24/7 platform monitoring ensure that your
                                assets are protected in all aspects.</p>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className="your_trusted">
                <div className="contain-width">
                    <h2 className="h_2" >Your Trusted Crypto Exchange</h2>
                    <p className="s_h" >Buy, trade, and hold 150+ cryptocurrencies on Deepcoin</p>
                    <Grid container spacing={5} >
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: "flex" }} >
                            <div className="box">
                                <div className="img_box">
                                    <img src={y1} alt="img" />
                                </div>
                                <h5>Superb R&D</h5>
                                <p>Self-developed third-gen trading system from scratch.Exclusive features to give you the ultimate trading experience without fail.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: "flex" }} >
                            <div className="box">
                                <div className="img_box">
                                    <img src={y2} alt="img" />
                                </div>
                                <h5>Global Innovative Team</h5>
                                <p>Blockchain & tech specialists, culturally diverse team deeply involved in the digital currency field for many years.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: "flex" }} >
                            <div className="box">
                                <div className="img_box">
                                    <img src={y3} alt="img" />
                                </div>
                                <h5>Super Trade</h5>
                                <p>Exclusively launched a new Spot Assets function, allowing you more visibility into your direct crypto purchases and the P&L generated from sales.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: "flex" }} >
                            <div className="box">
                                <div className="img_box">
                                    <img src={y4} alt="img" />
                                </div>
                                <h5>24/7 Multi Lingual Support</h5>
                                <p>One minute response time. Dedicated to getting you solutions</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className="why_choose">
                <div className="contain-width">
                    <Grid container spacing={2} sx={{ justifyContent: "center" }} >
                        <Grid item xs={12} sm={12} md={12} lg={10} xl={10} sx={{ margin: "auto" }} >
                            <h2 className="h_2" >Why choose WEEX?</h2>
                             

                            <div className="flx">
                                {data.map((item, index) => (
                                    <div
                                        key={index}
                                        onMouseEnter={() => setHoverIndex(index)}
                                        onMouseLeave={() => setHoverIndex(null)}
                                        className={hoverIndex === index ? "hover" : ""}
                                    >
                                        <h6>{item.title}</h6>
                                        <p>{item.description}</p>
                                        <img src={item.img} alt="img" />
                                    </div>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className="copy_trading">
                <div className="contain-width">
                    <Grid container spacing={2} sx={{ justifyContent: "center" }} >
                        <Grid item xs={12} sm={12} md={12} lg={10} xl={10} sx={{ margin: "auto" }} >

                            <div className="flx_box flx_box_chg">
                                <Grid item xs={12} sm={12} md={12} lg={8} xl={8} sx={{ margin: "auto" }} >
                                    <div className="copy" >Copy Trading</div>
                                    <h2 className="h_2" >Never miss another market movement</h2>
                                    <span>Save time and effort by copying top traders</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ margin: "auto" }} >
                                    <Link to={"/copytrade"} className="start" >Start Copy Trading  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8.89789 0.759766L19.0349 10.8968L16.8627 13.069L8.8976 21.0341L6.72534 18.8619L13.4391 12.1481H0.581589V9.07611H12.8697L6.72561 2.93201L8.89789 0.759766Z" fill="#FF7028" /></svg></Link>
                                </Grid>
                            </div>
                            <div className="flx_box">
                                <div>
                                    <h5>5,000+</h5>
                                    <div className="sub_n">Professional traders</div>
                                </div>
                                <div>
                                    <h5>50,000+</h5>
                                    <div className="sub_n">Followers</div>
                                </div>
                                <div>
                                    <h5>$800,000,000+</h5>
                                    <div className="sub_n">Followers</div>
                                </div>
                            </div>

                        </Grid>
                    </Grid>

                </div>
            </section>
            <section className="card_box">
                <div className="contain-width">
                    <Grid container spacing={2} sx={{ justifyContent: "center" }} >
                        <Grid item xs={12} sm={12} md={12} lg={4} xl={3} >
                            <div className="box">
                                <div className="h_flx">
                                    <div className="flx" >
                                        <img src={prf} alt="img" />
                                        <div class="w-100">
                                            <h5>Xiao Hai</h5>
                                            <span>Too busy making money to …</span>
                                        </div>
                                    </div>
                                    <div>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1659 8.74848L7.8859 7.86032C7.8859 7.86032 7.4505 7.69148 7.28222 7.52628C7.17386 7.41876 7.18142 7.16816 7.27746 6.84616C7.3735 6.52444 8.54194 5.2174 8.54194 4.02992C8.54194 2.19676 7.3357 0.709961 5.84918 0.709961C4.36238 0.709961 3.15754 2.19676 3.15754 4.02992C3.15754 5.16756 4.19914 6.52332 4.32738 6.76888C4.4559 7.01584 4.42482 7.3916 4.32374 7.50472C4.17142 7.6758 3.61394 7.8466 3.61394 7.8466L1.55846 8.7622C1.07826 8.93413 0.70166 9.38683 0.70166 9.89873V10.1406C0.70166 10.6981 1.15442 11.0397 1.71078 11.0397H10.0114C10.5677 11.0397 11.0213 10.6981 11.0213 10.1406V9.89873C11.0227 9.38663 10.6461 8.92013 10.1659 8.74848Z" fill="#D1D1D2" /></svg>
                                        <div>8 / <div className="grey">100</div></div>
                                    </div>
                                </div>
                                <div className="flx">
                                    <div>
                                        <div className="green">+6.64%</div>
                                        <span>ROI</span>
                                    </div>
                                    <div className="days">30 days</div>
                                </div>
                                <img src={card_chart} alt="img" />
                                <div className="f_box">
                                    <div>
                                        <div>Total PnL (3W)</div>
                                        <div>$356.54</div>
                                    </div>
                                    <div>
                                        <div>Copy trading PnL (3W)</div>
                                        <div>$29550.81</div>
                                    </div>
                                    <div>
                                        <div>Win rate (3W)</div>
                                        <div>65.80%</div>
                                    </div>
                                    <div>
                                        <div className="coins" >
                                            <img src={kcs} alt="img" />
                                            <img src={scr} alt="img" />
                                            <img src={cat} alt="img" />
                                        </div>
                                        <div>
                                            <img src={card_icon} alt="img" className="icon" />10%</div>
                                    </div>
                                </div>
                                <Link to={"#"} className="copy_btn" >Copy</Link>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4} xl={3} >
                            <div className="box">
                                <div className="h_flx">
                                    <div className="flx" >
                                        <img src={prf} alt="img" />
                                        <div class="w-100">
                                            <h5>Xiao Hai</h5>
                                            <span>Too busy making money to …</span>
                                        </div>
                                    </div>
                                    <div>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1659 8.74848L7.8859 7.86032C7.8859 7.86032 7.4505 7.69148 7.28222 7.52628C7.17386 7.41876 7.18142 7.16816 7.27746 6.84616C7.3735 6.52444 8.54194 5.2174 8.54194 4.02992C8.54194 2.19676 7.3357 0.709961 5.84918 0.709961C4.36238 0.709961 3.15754 2.19676 3.15754 4.02992C3.15754 5.16756 4.19914 6.52332 4.32738 6.76888C4.4559 7.01584 4.42482 7.3916 4.32374 7.50472C4.17142 7.6758 3.61394 7.8466 3.61394 7.8466L1.55846 8.7622C1.07826 8.93413 0.70166 9.38683 0.70166 9.89873V10.1406C0.70166 10.6981 1.15442 11.0397 1.71078 11.0397H10.0114C10.5677 11.0397 11.0213 10.6981 11.0213 10.1406V9.89873C11.0227 9.38663 10.6461 8.92013 10.1659 8.74848Z" fill="#D1D1D2" /></svg>
                                        <div>8 / <div className="grey">100</div></div>
                                    </div>
                                </div>
                                <div className="flx">
                                    <div>
                                        <div className="green">+6.64%</div>
                                        <span>ROI</span>
                                    </div>
                                    <div className="days">30 days</div>
                                </div>
                                <img src={card_chart} alt="img" />
                                <div className="f_box">
                                    <div>
                                        <div>Total PnL (3W)</div>
                                        <div>$356.54</div>
                                    </div>
                                    <div>
                                        <div>Copy trading PnL (3W)</div>
                                        <div>$29550.81</div>
                                    </div>
                                    <div>
                                        <div>Win rate (3W)</div>
                                        <div>65.80%</div>
                                    </div>
                                    <div>
                                        <div className="coins" >
                                            <img src={kcs} alt="img" />
                                            <img src={scr} alt="img" />
                                            <img src={cat} alt="img" />
                                        </div>
                                        <div>
                                            <img src={card_icon} alt="img" className="icon" />10%</div>
                                    </div>
                                </div>
                                <Link to={"#"} className="copy_btn" >Copy</Link>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4} xl={3} >
                            <div className="box">
                                <div className="h_flx">
                                    <div className="flx" >
                                        <img src={prf} alt="img" />
                                        <div class="w-100">
                                            <h5>Xiao Hai</h5>
                                            <span>Too busy making money to …</span>
                                        </div>
                                    </div>
                                    <div>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1659 8.74848L7.8859 7.86032C7.8859 7.86032 7.4505 7.69148 7.28222 7.52628C7.17386 7.41876 7.18142 7.16816 7.27746 6.84616C7.3735 6.52444 8.54194 5.2174 8.54194 4.02992C8.54194 2.19676 7.3357 0.709961 5.84918 0.709961C4.36238 0.709961 3.15754 2.19676 3.15754 4.02992C3.15754 5.16756 4.19914 6.52332 4.32738 6.76888C4.4559 7.01584 4.42482 7.3916 4.32374 7.50472C4.17142 7.6758 3.61394 7.8466 3.61394 7.8466L1.55846 8.7622C1.07826 8.93413 0.70166 9.38683 0.70166 9.89873V10.1406C0.70166 10.6981 1.15442 11.0397 1.71078 11.0397H10.0114C10.5677 11.0397 11.0213 10.6981 11.0213 10.1406V9.89873C11.0227 9.38663 10.6461 8.92013 10.1659 8.74848Z" fill="#D1D1D2" /></svg>
                                        <div>8 / <div className="grey">100</div></div>
                                    </div>
                                </div>
                                <div className="flx">
                                    <div>
                                        <div className="green">+6.64%</div>
                                        <span>ROI</span>
                                    </div>
                                    <div className="days">30 days</div>
                                </div>
                                <img src={card_chart} alt="img" />
                                <div className="f_box">
                                    <div>
                                        <div>Total PnL (3W)</div>
                                        <div>$356.54</div>
                                    </div>
                                    <div>
                                        <div>Copy trading PnL (3W)</div>
                                        <div>$29550.81</div>
                                    </div>
                                    <div>
                                        <div>Win rate (3W)</div>
                                        <div>65.80%</div>
                                    </div>
                                    <div>
                                        <div className="coins" >
                                            <img src={kcs} alt="img" />
                                            <img src={scr} alt="img" />
                                            <img src={cat} alt="img" />
                                        </div>
                                        <div>
                                            <img src={card_icon} alt="img" className="icon" />10%</div>
                                    </div>
                                </div>
                                <Link to={"#"} className="copy_btn" >Copy</Link>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
           
            <section className="ban_blw ban_blw_chg">
                <div className="contain-width">
                    <div className="slide">
                        <img src={h1} alt="img" />
                        <img src={h2} alt="img" />
                        <img src={h3} alt="img" />
                        <img src={h4} alt="img" />
                        <img src={h5} alt="img" />
                        <img src={h6} alt="img" />
                        <img src={h7} alt="img" />
                        <img src={h8} alt="img" />
                        <img src={h9} alt="img" />
                        <img src={h10} alt="img" />
                    </div>
                    <div className="slide">
                        <img src={h1} alt="img" />
                        <img src={h2} alt="img" />
                        <img src={h3} alt="img" />
                        <img src={h4} alt="img" />
                        <img src={h5} alt="img" />
                        <img src={h6} alt="img" />
                        <img src={h7} alt="img" />
                        <img src={h8} alt="img" />
                        <img src={h9} alt="img" />
                        <img src={h10} alt="img" />
                    </div>
                </div>
            </section>
            <section className="trade_now">
                <div className="contain-width">
                    {!status && <div>
                        <h2 className="h_2" >Trade Now</h2>
                        <p>Sign up in 10 seconds to explore endless trading possibilities</p>
                        <Link to={"/register"} className="start" >Sign Up <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8.75722 0.759766L18.8942 10.8968L16.722 13.069L8.75693 21.0341L6.58467 18.8619L13.2984 12.1481H0.440918V9.07611H12.729L6.58494 2.93201L8.75722 0.759766Z" fill="#fff" /></svg></Link>

                    </div>}
                </div>
            </section> */}
      <Footer />
    </div>
  );
};

export default Home;
